import { render, staticRenderFns } from "./ButtonWithConfirmation.vue?vue&type=template&id=1d83ebc1&scoped=true&"
import script from "./ButtonWithConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonWithConfirmation.vue?vue&type=style&index=0&id=1d83ebc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83ebc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
